/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import {
  useTraceFiltersContext,
  defaultFilters,
} from "../../../contexts/trazabilidad/TraceFiltersContext";
import CustomDateField from "../../../components/formCamps/CustomDateField";

const getEstats = () => {
  return [
    <MenuItem key="SD" value="">
      Sense determinar...
    </MenuItem>,
    <MenuItem key="OK" value="OK">
      Correcte
    </MenuItem>,
    <MenuItem key="KO" value="KO">
      Error
    </MenuItem>,
    <MenuItem key="PENDENT" value="PENDENT">
      Pendent
    </MenuItem>,
  ];
};

const getEstatsTercer = () => {
  return [
    <MenuItem key="SD" value="">
      Sense determinar...
    </MenuItem>,
    <MenuItem key="OK" value="OK">
      OK
    </MenuItem>,
    <MenuItem key="PENDENT" value="PENDENT">
      PENDENT
    </MenuItem>,
    <MenuItem key="KO" value="KO">
      KO
    </MenuItem>,
  ];
};

const dateFormat = "DD/MM/YYYY";

function TraceFilterBox({ submitFilters }) {
  const { filters, setFilters } = useTraceFiltersContext();

  //An alternative to manual debounce is using a third party library like reack-hook-forms
  const [localFilters, setLocalFilters] = useState(filters);
  const [debouncedValues, setDebouncedValues] = useState(filters);

  const {
    app,
    servei,
    estatDoctram,
    estat,
    estatTercers,
    reintents,
    dataInici,
    dataFi,
    modalitat,
    idPeticio,
    id,
    valor,
    descErr,
  } = localFilters;

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setLocalFilters((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleDateChange = (fieldName, date) => {
    const dateStringed = date.format('DD/MM/YYYY')
    setLocalFilters((prevValues) => ({
      ...prevValues,
      [fieldName]: dateStringed,
    }));
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValues(localFilters);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [localFilters]);

  // Apply the debounced values to your filters
  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...localFilters,
    }));
  }, [debouncedValues]);

  const resetFilters = (event) => {
    event.preventDefault();
    setLocalFilters(defaultFilters);
  };

  const renderButtons = () => {
    return (
      <Grid item xs={12}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Stack direction="row" spacing={2}>
            <Button
              onClick={resetFilters}
              type="button"
              variant="contained"
              color="secondary"
            >
              {"Neteja filtres"}
            </Button>
            <Button type="submit" variant="contained">
              {"Filtra"}
            </Button>
          </Stack>
        </Stack>
      </Grid>
    );
  };

  const renderFilterInputs = () => {
    return (
      <>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-app"
              label={"Aplicació"}
              name="app"
              value={app}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-servei"
              label={"Servei"}
              name="servei"
              value={servei}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-modalitat"
              label={"Modalitat"}
              name="modalitat"
              value={modalitat}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <InputLabel id="id-estat-select-label">Estat</InputLabel>
            <Select
              labelId="id-estat-select-label"
              id="id-estat-select"
              value={estat}
              name="estat"
              onChange={handleInputChange}
              size="small"
            >
              {getEstats()}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <InputLabel id="id-estat-doctram-select-label">
              Estat DOCTRAM
            </InputLabel>
            <Select
              labelId="id-estat-doctram-select-label"
              id="id-estat-doctram-select"
              value={estatDoctram}
              name="estatDoctram"
              onChange={handleInputChange}
              size="small"
            >
              {getEstats()}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <InputLabel id="id-estat-tercer-select-label">Estat tercer</InputLabel>
            <Select
              labelId="id-estat-tercer-select-label"
              id="id-estat-tercer-select"
              value={estatTercers}
              name="estatTercers"
              onChange={handleInputChange}
              size="small"
            >
              {getEstatsTercer()}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-reintent"
              label={"Nº Reintents"}
              name="reintents"
              value={reintents}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-id"
              label={"Identificador"}
              name="id"
              value={id}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-idPeticio"
              label={"Id Peticio"}
              name="idPeticio"
              value={idPeticio}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-descErr"
              label={"Descripció Error"}
              name="descErr"
              value={descErr}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl sx={{ display: "flex" }}>
            <TextField
              id="id-valor"
              label={"Valor traça param"}
              name="valor"
              value={valor}
              onChange={handleInputChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FormControl sx={{ display: "flex" }}>
            <CustomDateField
              name="dataInici"
              label="Data Inici"
              dateFormat={dateFormat}
              selectedDate={dataInici}
              handleInputChange={handleDateChange}
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FormControl sx={{ display: "flex" }}>
          <CustomDateField
              name="dataFi"
              label="Data Fi"
              dateFormat={dateFormat}
              selectedDate={dataFi}
              handleInputChange={handleDateChange}
              size="small"
            />
          </FormControl>
        </Grid>
      </>
    );
  };

  return (
    <Paper elevation={4} sx={{ boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.46)" }}>
      <Box
        component="form"
        onSubmit={(event) => submitFilters(event)}
        sx={{ m: 3 }}
        noValidate
      >
        <Grid container direction={"row"} spacing={2} alignItems={"center"}>
          {renderFilterInputs()}
          {renderButtons()}
        </Grid>
      </Box>
    </Paper>
  );
}

export default TraceFilterBox;
